import type { ComponentProps } from 'react';

import { cn, CarouselDots } from '@boc/ui';

import { JigsawIcon } from '~/local/components/icons';

export {
  type CarouselApi,
  Carousel,
  CarouselContent,
  CarouselItem,
  useCarousel,
} from '@boc/ui';

const rotations = [
  ...[...Array(Math.floor(365 / 17) + 1).keys()].map((n) => `rotate-[${17 * n}deg]`),
];

/**
 * Jigsaw Nation's dot navigation: the shared dots with a jigsaw piece in place of the plain dot,
 * each piece rotated a little further and every other one mirrored.
 */
export const CarouselNavigation = (props: Omit<ComponentProps<'div'>, 'children'>) => (
  <CarouselDots
    renderDot={({ index, selected }) => (
      <JigsawIcon
        className={cn(
          'text-primary-2-80',
          selected ? '' : 'opacity-25',
          rotations[index % rotations.length],
          index % 2 && '-scale-100'
        )}
      />
    )}
    {...props}
  />
);
